module.exports = __webpack_public_path__ + "img/gb-whatsapp-pro-lock-feature.f77e1dd2.webp";